import { ConversationsSidebarPanel } from './ConversationsSidebarPanel'
import { ExpansionPanelProps } from '@forgeglobal/design-framework'
import { InteractionFilter, useAccountInteractionsQuery } from 'graphql/bindings/AdminBindings'
import React, { useState } from 'react'

interface AccountConversationsSidebarPanelProps extends Omit<ExpansionPanelProps, 'children'> {
  accountId: string
  currentPage: string
}

export const AccountConversationsSidebarPanel: React.FC<AccountConversationsSidebarPanelProps> = ({
  accountId,
  currentPage,
  ...props
}) => {
  const [groupFilter, setGroupFilter] = useState(InteractionFilter.All)
  const { data } = useAccountInteractionsQuery({
    variables: { id: accountId, groupFilter },
  })
  const account = data?.account
  const interactions = account?.interactions ?? []
  const accountName = account?.name ?? ''
  return (
    <ConversationsSidebarPanel
      interactions={interactions}
      accountName={accountName}
      accountId={accountId}
      currentId={accountId}
      isAccount
      currentPage={currentPage}
      filter={groupFilter}
      setFilter={setGroupFilter}
      {...props}
    />
  )
}
